module.exports = __webpack_public_path__ + "static/img/scgt.73779fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/scgt.png
// module id = BEbi
// module chunks = 1